import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">3.0.3 Case 3</h1>
            <p className="me-4">Estimated time to complete: 3-5 minutes</p>
          </section>
          <ModuleQuestion
            correctAnswer="B"
            assessmentName="self_assessment_103"
            videoTranscript={
              <>
                <p>
                  <strong>AUDIO</strong>
                  <br />
                  VO: (FEMALE)
                  <br />
                  This is self-assessment case number 103. This is a negative
                  case. The size and contrast have already been adjusted. In
                  this particular case, it was important to adjust the contrast
                  secondary to increased activity in the salivary glands, seen
                  on the left here and on the right over here. The cerebellum
                  shows normal gray-white contrast for this patient. As we move
                  superiorly, we enter into the temporal and occipital lobes,
                  seen here. White matter tracts are identifiable on the left
                  and on the right. Normal gray-white contrast can be seen on
                  the right and the left as well. As we move superiorly, we
                  enter into the frontal lobes bilaterally. The frontal lobes
                  also show normal gray-white contrast. This range of contrast
                  is within the normal limit. In this particular region, there
                  may be concern that this focal uptake is in the gray matter.
                  However, as you move superiorly, it is clear that this is
                  actually white matter extending outwards into the gray matter.
                  Therefore, there is normal gray-white contrast on the right as
                  well. As we continue moving upward, we enter into the parietal
                  region, where white matter tracts can be easily seen moving
                  from the front of the brain to the posterior brain. This can
                  be seen on the left-hand side as well as on the right-hand
                  side. Furthermore, there is no increased activity in the
                  medial parietal gray matter, seen here on the left and here on
                  the right. Therefore, there is normal gray-white contrast in
                  the parietal lobes bilaterally. Moving through the top of the
                  brain, no increased gray matter uptake is identified.
                  Therefore, this is a negative scan. If you called this scan
                  positive, I invite you to look at this case, once again, in
                  the MIM Cloud Viewer in order to gain a better understanding
                  of the range of normal gray-white contrast that may be seen.
                </p>
              </>
            }
            previousLesson="/module-3/module-3-0-2"
            nextLesson="/module-3/module-3-0-4"
            iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_34870289&entry_id=1_h2aknmpu&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
            questionType="assessment"
            videoId="1_h2aknmpu"
          />
        </main>
      </div>
    </div>
  );
};

export default Module_1_0;
